import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CustomPagination.css";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";

const CustomPagination = ({
  page,
  pageSize,
  pageCount,
  totalRecordCount,
  onPageChange,
  rowsPerPageOptions,
  onPageSizeChange,
  disableSelectPageSize
}) => {
  const paginationItems = [];
  const maxDisplayedPages = 5;
  const halfWay = Math.floor(maxDisplayedPages / 2);

  const startPage = Math.max(1, page - halfWay);
  const endPage = Math.min(pageCount, page + halfWay);

  if (startPage > 2) {
    paginationItems.push(
      <PaginationItem key={1}>
        <PaginationLink onClick={(e) => {
            e.preventDefault();
            onPageChange(1);
          }} href="#">
        {1}
        </PaginationLink>
      </PaginationItem>
    );
    // paginationItems.push(<PaginationItem key="start-ellipsis" disabled><PaginationLink href="#">...</PaginationLink></PaginationItem>);
  } else if (startPage === 2) {
    paginationItems.push(
      <PaginationItem key={1}>
        <PaginationLink onClick={(e) => {
            e.preventDefault();
            onPageChange(1);
          }} href="#">
        {1}
        </PaginationLink>
      </PaginationItem>
    );
  }

  for (let i = startPage; i <= endPage; i++) {
    paginationItems.push(
      <PaginationItem key={i} active={i === page}>
        <PaginationLink onClick={(e) => {
              e.preventDefault();
              onPageChange(i);
            }} href="#">
          {i}
        </PaginationLink>
      </PaginationItem>
    );
  }

  if (endPage < pageCount - 1) {
    paginationItems.push(<PaginationItem key="end-ellipsis" disabled><PaginationLink href="#">...</PaginationLink></PaginationItem>);
    paginationItems.push(
      <PaginationItem key={pageCount}>
        <PaginationLink onClick={(e) => {
            e.preventDefault();
            onPageChange(pageCount);
          }} href="#">
        {pageCount}
        </PaginationLink>
      </PaginationItem>
    );
  } else if (endPage === pageCount - 1) {
    paginationItems.push(
      <PaginationItem key={pageCount}>
        <PaginationLink onClick={(e) => {
            e.preventDefault();
            onPageChange(pageCount);
          }} href="#">
        {pageCount}
        </PaginationLink>
      </PaginationItem>
    );
  }

  return (
    <div>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ padding: "10px" }}
      >
        <div>
        { !disableSelectPageSize && <select
            className="custom-select"
            value={pageSize}
            onChange={(e) => {
              onPageChange(1, true);
              onPageSizeChange(parseInt(e.target.value));
            }}
            style={{ marginLeft: "5px" }}
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>}
        </div>
        <Pagination className="justify-content-end">
          <PaginationItem>
            <PaginationLink
              previous
              href="#"
              className="page-link"
              aria-label="Previous"
              onClick={(e) => {
                e.preventDefault();
                if (page > 1) {
                  onPageChange(page - 1);
                }
              }}
            >
              <ArrowLeft />
            </PaginationLink>
          </PaginationItem>
          {paginationItems}
          <PaginationItem>
            <PaginationLink
              next
              href="#"
              className="page-link"
              aria-label="Next"
              onClick={(e) => {
                e.preventDefault();
                if (page < pageCount) {
                  onPageChange(page + 1);
                }
              }}
            >
              <ArrowRight />
            </PaginationLink>
          </PaginationItem>
        </Pagination>
      </div>
    </div>
  );
};

export default CustomPagination;